<template>
  
    <v-sheet outlined class="text-body-2">
      <v-container fluid>
        <p class="text-h6">Match Summary</p>

        <v-row dense>
          <v-col> </v-col>
          <v-col>Case Data</v-col>
          <v-col> </v-col>
          <v-col>Sanction Data</v-col>
        </v-row>

        <v-row
          v-for="(similarField, index) in summary.matchFields"
          :key="index"
          dense
          align="center">

          <v-col cols="12">
            <v-divider />
          </v-col>
          <v-col class="font-weight-bold">{{ similarField.fieldName }}</v-col>
          <v-col>{{ similarField.caseField }}</v-col>
          <v-col>
            <v-chip
              v-if="similarField.similarity == 'STRONG'"
              small
              color="green"
              dark
              class="font-weight-bold"
              >=</v-chip
            >
            <v-chip v-else small color="primary" dark class="font-weight-black">≈</v-chip>
          </v-col>
          <!-- <v-col>{{ similarField.similarityScore }}</v-col> -->
          <v-col>
            <span v-if="similarField.sanctionFieldNote" class="overline">
              {{ similarField.sanctionFieldNote }}
              <br />
            </span>
            <span class="caps">{{ similarField.sanctionField }}</span>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
</template>

<script>
export default {
  name: "MatchSummary",
  data() {
    return {};
  },
  props: {
    summary: {},
  }
};
</script>